// Resolves a company-profile image to something renderable, from either side of
// a save: a freshly picked File (not uploaded yet) or a stored mediaId.
//
// A pending pick always wins, so the card shows the local file the instant it is
// chosen and never flashes the old stored image behind it. The object URL is
// revoked on unmount, and the resolver query is skipped while a pick is pending
// so a soon-to-be-replaced image is never fetched.
//
// Same shape as form-templates-page/useFieldImageUrl, with the form-scoped
// resolver swapped for the company one. Call at component top level, never
// inside a branch.

import { useEffect, useState } from 'react';
import { useGetCompanyProfileMediaQuery } from '@/api/endpoints/mediaApi';

export const useCompanyMediaUrl = (
  mediaId: string | null | undefined,
  pendingFile?: File | null,
): string | undefined => {
  const pending = pendingFile instanceof File ? pendingFile : null;

  const [objectUrl, setObjectUrl] = useState<string>();
  useEffect(() => {
    if (!pending) {
      setObjectUrl(undefined);
      return;
    }
    const url = URL.createObjectURL(pending);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [pending]);

  const { data } = useGetCompanyProfileMediaQuery(mediaId ?? '', {
    skip: !mediaId || Boolean(pending),
  });

  return objectUrl ?? data?.url;
};

export default useCompanyMediaUrl;
